<div class="{{ 'MuiPaper-root MuiAlert-root  MuiPaper-elevation6 ' + color }}">
  @if (icon) {
    <div class="MuiAlert-icon">
      <mat-icon>{{ icon }}</mat-icon>
    </div>
  }
  @if (message) {
    <div class="MuiAlert-message">
      {{ message }}
    </div>
  }
</div>
